import React, { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../pages/Home/Home'
import Jobs from "../pages/Jobs/Jobs"
import JobDetail from '../pages/JobDetail/JobDetail'
import Application from '../pages/Application/Application'
import Login from '../pages/Login/Login'
import { useAppSelector } from "../redux/store"
import CreateJob from '../pages/CreateJob/CreateJob'
import AboutUs from '../pages/AboutUs/AboutUs'
import { useTranslation } from 'react-i18next'

export default function Root() {

    const accsessToken = useAppSelector(state => state.auth.accessToken)

    const { ready } = useTranslation();

    if (!ready) return <div>Yükleniyor...</div>;


    return (
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/jobs' element={<Jobs />} />
            <Route path='/job-details/:id' element={<JobDetail />} />
            <Route path='/job-details/:id/apply' element={<Application />} />
            <Route path='/admin-login' element={<Login />} />
            <Route path='/about-us' element={<AboutUs />} />
            {accsessToken && <Route path='create-job' element={<CreateJob />} />}
        </Routes>
    )
}
